import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePageTitle } from '../hooks/usePageTitle'
import useLang from '../hooks/useLang'
import './Home.css'

// Импорты изображений
import logoQaraa from '../images/logo-qaraa.webp'
import qaraaCrmLogo from '../images/qaraaxqaraa-crm.webp'
import secutiryusIcon from '../images/secutiryus.webp'
import chestnostusIcon from '../images/chestnostus.webp'
import inovationusIcon from '../images/inovationus.webp'
import supportusIcon from '../images/supportus.webp'
import razvitieusIcon from '../images/razvitieus.webp'
import dostupusIcon from '../images/dostupus.webp'
import whatsappIcon from '../images/whatsapp.webp'
import telegramIcon from '../images/telegram.webp'
import callIcon from '../images/call.webp'
import qaraasec2Image from '../images/sec.webp'
import kakmiImage from '../images/kakmi.webp'
import biz1Image from '../images/biz1.webp'
import biz2Image from '../images/biz2.webp'
import biz3Image from '../images/biz3.webp'
import biz4Image from '../images/biz4.webp'
import heartqaraaImage from '../images/heartqaraa.webp'
import smileImage from '../images/smile.webp'

export default function Aboutus() {
  const { lang, changeLang, t, languages } = useLang()
  usePageTitle(t.aboutPageTitle)
  const navigate = useNavigate()
  const [openFaq, setOpenFaq] = useState(null)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [langDropdownOpen, setLangDropdownOpen] = useState(false)
  const langRef = useRef(null)

  const [loadMap, setLoadMap] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => setLoadMap(true), 2000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) setLangDropdownOpen(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
    window.scrollTo(0, 0)
  }, [])

  const values = t.aboutValues.map((v, i) => ({
    ...v,
    icon: [secutiryusIcon, chestnostusIcon, inovationusIcon, supportusIcon, razvitieusIcon, dostupusIcon][i]
  }))

  const faqs = t.aboutFaqs

  const contacts = [
    { icon: whatsappIcon, title: 'WhatsApp', value: '+7 777 830 75 88', link: 'https://wa.me/77778307588' },
    { icon: telegramIcon, title: 'Telegram', value: '@sakurariley', link: 'https://t.me/sakurariley' },
    { icon: callIcon, title: t.aboutContactPhone, value: '+7 777 830 75 88', link: 'tel:+77778307588' }
  ]

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F2F2F7',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Fixed Header */}
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: 'rgba(255, 255, 255, 0.72)',
        backdropFilter: 'saturate(180%) blur(20px)',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        transition: 'all 0.3s ease'
      }}>
        <div className="home-header-container" style={{
          maxWidth: '1440px',
          margin: '0 auto',
          padding: '20px 48px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div className="home-logo-container" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            cursor: 'pointer',
            transition: 'opacity 0.3s ease',
            opacity: 1
          }}
            onClick={() => navigate('/')}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            <img
              src={logoQaraa}
              alt="qaraa"
              className="home-logo"
              style={{
                height: '42px',
                width: 'auto',
                transition: 'transform 0.3s ease'
              }}
            />
            <div>
              <div className="home-logo-title" style={{
                fontSize: '17px',
                fontWeight: '600',
                color: '#1C1C1E',
                lineHeight: '1.2'
              }}>
                <span className="logo-title-line1">qaraa.asia</span>
                <br className="mobile-break" />
                <span className="logo-title-line2 mobile-only-subtitle" style={{ fontSize: '12px', color: '#8E8E93', fontWeight: '500' }}>{t.logoSubtitle}</span>
              </div>
              <div className="home-logo-subtitle desktop-only-subtitle" style={{
                fontSize: '12px',
                color: '#8E8E93',
                marginTop: '4px'
              }}>
                {t.logoSubtitle}
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <div ref={langRef} style={{ position: 'relative', marginRight: '6px' }}>
              <button onClick={() => setLangDropdownOpen(!langDropdownOpen)} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: langDropdownOpen ? 'rgba(0,0,0,0.06)' : 'transparent', border: 'none', borderRadius: '100px', fontSize: '14px', fontWeight: '500', color: '#8E8E93', cursor: 'pointer', transition: 'all 0.2s ease', fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif' }} onMouseEnter={(e) => { if (!langDropdownOpen) e.currentTarget.style.background = 'rgba(0,0,0,0.04)' }} onMouseLeave={(e) => { if (!langDropdownOpen) e.currentTarget.style.background = 'transparent' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>
                <span className="lang-text-label">{t.languageLabel}</span>
                <svg className="lang-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: langDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}><polyline points="6 9 12 15 18 9" /></svg>
              </button>
              {langDropdownOpen && (<div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, background: '#FFFFFF', borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.12)', padding: '6px', minWidth: '140px', zIndex: 200 }}>{languages.map((l) => (<button key={l.code} onClick={() => { changeLang(l.code); setLangDropdownOpen(false) }} style={{ display: 'block', width: '100%', padding: '10px 14px', background: lang === l.code ? 'rgba(0,122,255,0.08)' : 'transparent', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: lang === l.code ? '600' : '400', color: lang === l.code ? '#007AFF' : '#1C1C1E', cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s ease', fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif' }} onMouseEnter={(e) => { if (lang !== l.code) e.currentTarget.style.background = 'rgba(0,0,0,0.04)' }} onMouseLeave={(e) => { if (lang !== l.code) e.currentTarget.style.background = 'transparent' }}>{l.label}</button>))}</div>)}
            </div>
            <button
              onClick={() => navigate('/login')}
              className="home-header-button-login"
              style={{
                padding: '10px 22px',
                background: 'transparent',
                border: 'none',
                borderRadius: '100px',
                fontSize: '15px',
                fontWeight: '600',
                color: '#000000',
                cursor: 'pointer',
                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'relative',
                letterSpacing: '-0.3px',
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(0, 0, 0, 0.06)'
                e.target.style.transform = 'scale(1.02)'
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent'
                e.target.style.transform = 'scale(1)'
              }}
            >
              {t.login}
            </button>
            <button
              onClick={() => navigate('/login?mode=register')}
              className="home-header-button-register"
              style={{
                padding: '10px 22px',
                background: '#FFFFFF',
                border: '1.5px solid #007AFF',
                borderRadius: '100px',
                fontSize: '15px',
                fontWeight: '600',
                color: '#007AFF',
                cursor: 'pointer',
                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                letterSpacing: '-0.3px',
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#007AFF'
                e.target.style.color = '#FFFFFF'
                e.target.style.transform = 'scale(1.02)'
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#FFFFFF'
                e.target.style.color = '#007AFF'
                e.target.style.transform = 'scale(1)'
              }}
            >
              {t.register}
            </button>

            {/* Мобильное меню - три полоски */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="home-mobile-menu-button"
              style={{
                display: 'none',
                padding: '8px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                flexDirection: 'column',
                gap: '5px'
              }}
            >
              <span style={{
                width: '24px',
                height: '2px',
                background: '#000000',
                borderRadius: '2px',
                transition: 'all 0.3s',
                transform: mobileMenuOpen ? 'rotate(45deg) translateY(7px)' : 'none'
              }}></span>
              <span style={{
                width: '24px',
                height: '2px',
                background: '#000000',
                borderRadius: '2px',
                transition: 'all 0.3s',
                opacity: mobileMenuOpen ? 0 : 1
              }}></span>
              <span style={{
                width: '24px',
                height: '2px',
                background: '#000000',
                borderRadius: '2px',
                transition: 'all 0.3s',
                transform: mobileMenuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none'
              }}></span>
            </button>
          </div>
        </div>
      </header>

      {/* Мобильное выпадающее меню */}
      {mobileMenuOpen && (
        <div
          className="home-mobile-menu"
          style={{
            position: 'fixed',
            top: '76px',
            left: 0,
            right: 0,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'saturate(180%) blur(20px)',
            WebkitBackdropFilter: 'saturate(180%) blur(20px)',
            borderBottom: 'none',
            padding: '16px 20px',
            zIndex: 99,
            display: 'none',
            flexDirection: 'column',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
          }}
        >
          <button
            onClick={() => {
              navigate('/login')
              setMobileMenuOpen(false)
            }}
            style={{
              padding: '12px 20px',
              background: 'rgba(0, 0, 0, 0.06)',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: '600',
              color: '#000000',
              cursor: 'pointer',
              width: '100%',
              letterSpacing: '-0.3px',
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
              transition: 'all 0.2s ease'
            }}
          >
            {t.login}
          </button>
          <button
            onClick={() => {
              navigate('/login?mode=register')
              setMobileMenuOpen(false)
            }}
            style={{
              padding: '12px 20px',
              background: 'linear-gradient(180deg, #007AFF 0%, #0051D5 100%)',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: '600',
              color: '#FFFFFF',
              cursor: 'pointer',
              width: '100%',
              letterSpacing: '-0.3px',
              boxShadow: '0 2px 8px rgba(0, 122, 255, 0.25)',
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
              transition: 'all 0.2s ease'
            }}
          >
            {t.register}
          </button>
        </div>
      )}

      {/* Hero */}
      <section className="home-hero-section" style={{
        paddingTop: '100px',
        paddingBottom: '100px',
        background: '#FFFFFF'
      }}>
        <div className="home-hero-container" style={{
          maxWidth: '1440px',
          margin: '0 auto',
          padding: '0 48px',
          display: 'grid',
          gridTemplateColumns: '1.3fr 1fr',
          gap: '80px',
          alignItems: 'center'
        }}>
          <div className="home-hero-text-wrapper">
            <h1 className="home-hero-title about-section-title about-hero-main-title" style={{
              fontSize: '80px',
              fontWeight: '600',
              lineHeight: '1.1',
              marginBottom: '32px',
              color: '#000000',
              letterSpacing: '-3px',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}>
              <span dangerouslySetInnerHTML={{ __html: t.aboutHeroTitle }} />
            </h1>
            <p className="home-hero-description about-hero-description-desktop" style={{
              fontSize: '24px',
              fontWeight: '400',
              color: '#666666',
              lineHeight: '1.5',
              margin: 0,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}>
              {t.aboutHeroDesc}
            </p>
          </div>

          <div className="home-human-container" style={{
            position: 'relative'
          }}>
            <img
              src={qaraasec2Image}
              className="home-human-image"
              alt="qaraa ecosystem"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </div>

          {/* Мобильное описание - показывается только на мобильном */}
          <p className="home-hero-description about-hero-description-mobile" style={{
            fontSize: '24px',
            fontWeight: '400',
            color: '#666666',
            lineHeight: '1.5',
            margin: 0,
            display: 'none',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}>
            {t.aboutHeroDesc}
          </p>
        </div>
      </section>

      {/* Story */}
      <section style={{
        padding: '80px 24px 60px',
        background: '#F2F2F7',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px',
        position: 'relative',
        zIndex: 2
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '24px' }}>

          {/* Desktop Row 1: История (left) + 2025 (right) */}
          <div className="about-row-1-desktop" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
            {/* История */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '32px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#8E8E93', letterSpacing: '1px' }}>
                  {t.aboutStoryLabel}
                </span>
                <img src={kakmiImage} alt="" style={{ height: '16px' }} />
              </div>
              <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1C1C1E', marginBottom: '20px' }}>
                {t.aboutStoryTitle}
              </h2>
              {t.aboutStoryParagraphs.map((p, i) => (
                <div key={i} style={{ fontSize: '15px', color: '#636366', lineHeight: '1.6', marginBottom: i === t.aboutStoryParagraphs.length - 1 ? '24px' : '16px' }} dangerouslySetInnerHTML={{ __html: p }} />
              ))}
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                <img src={qaraaCrmLogo} alt="qaraa × qaraa.crm" style={{ height: '120px' }} />
              </div>
            </div>

            {/* 2025 с neon-орбами */}
            <div style={{
              background: '#FAFAFA',
              borderRadius: '24px',
              padding: '40px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              border: '1px solid #E5E5EA',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute', top: '-60px', right: '-60px',
                width: '220px', height: '220px', borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(196, 184, 248, 0.55) 0%, transparent 70%)',
                pointerEvents: 'none'
              }} />
              <div style={{
                position: 'absolute', bottom: '-50px', left: '-50px',
                width: '200px', height: '200px', borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(248, 221, 184, 0.5) 0%, transparent 70%)',
                pointerEvents: 'none'
              }} />
              <div style={{
                fontSize: '80px', fontWeight: '700', color: '#1C1C1E',
                marginBottom: '12px', lineHeight: 1, letterSpacing: '-2px',
                position: 'relative', zIndex: 1
              }}>
                2025
              </div>
              <div style={{
                fontSize: '17px', fontWeight: '600', color: '#1C1C1E',
                marginBottom: '8px', position: 'relative', zIndex: 1
              }}>
                {t.aboutFoundedYear}
              </div>
              <div style={{ fontSize: '15px', color: '#8E8E93', position: 'relative', zIndex: 1 }}>
                qaraa.asia × qaraa.crm
              </div>
            </div>
          </div>

          {/* Mobile Row 1: 2025 (top) + История (bottom) */}
          <div className="about-row-1-mobile" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {/* 2025 с neon-орбами */}
            <div style={{
              background: '#FAFAFA',
              borderRadius: '24px',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              border: '1px solid #E5E5EA',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute', top: '-60px', right: '-60px',
                width: '220px', height: '220px', borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(196, 184, 248, 0.55) 0%, transparent 70%)',
                pointerEvents: 'none'
              }} />
              <div style={{
                position: 'absolute', bottom: '-50px', left: '-50px',
                width: '200px', height: '200px', borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(248, 221, 184, 0.5) 0%, transparent 70%)',
                pointerEvents: 'none'
              }} />
              <div style={{
                fontSize: '80px', fontWeight: '700', color: '#1C1C1E',
                marginBottom: '12px', lineHeight: 1, letterSpacing: '-2px',
                position: 'relative', zIndex: 1
              }}>
                2025
              </div>
              <div style={{
                fontSize: '17px', fontWeight: '600', color: '#1C1C1E',
                marginBottom: '8px', position: 'relative', zIndex: 1
              }}>
                {t.aboutFoundedYear}
              </div>
              <div style={{ fontSize: '15px', color: '#8E8E93', position: 'relative', zIndex: 1 }}>
                qaraa.asia × qaraa.crm
              </div>
            </div>

            {/* История */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '32px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#8E8E93', letterSpacing: '1px' }}>
                  {t.aboutStoryLabel}
                </span>
                <img src={kakmiImage} alt="" style={{ height: '16px' }} />
              </div>
              <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1C1C1E', marginBottom: '20px' }}>
                {t.aboutStoryTitle}
              </h2>
              {t.aboutStoryParagraphs.map((p, i) => (
                <div key={i} style={{ fontSize: '15px', color: '#636366', lineHeight: '1.6', marginBottom: i === t.aboutStoryParagraphs.length - 1 ? '24px' : '16px' }} dangerouslySetInnerHTML={{ __html: p }} />
              ))}
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                <img src={qaraaCrmLogo} alt="qaraa × qaraa.crm" style={{ height: '120px' }} />
              </div>
            </div>
          </div>

          <div className="about-mobile-line" />

          {/* Row 2: 2026 (neon) + Улучшение экосистемы */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
            {/* 2026 с neon-орбами */}
            <div style={{
              background: '#FAFAFA',
              borderRadius: '24px',
              padding: '40px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              border: '1px solid #E5E5EA',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute', top: '-60px', left: '-60px',
                width: '220px', height: '220px', borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(184, 228, 248, 0.55) 0%, transparent 70%)',
                pointerEvents: 'none'
              }} />
              <div style={{
                position: 'absolute', bottom: '-50px', right: '-50px',
                width: '200px', height: '200px', borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(248, 184, 220, 0.45) 0%, transparent 70%)',
                pointerEvents: 'none'
              }} />
              <div style={{
                fontSize: '80px', fontWeight: '700', color: '#1C1C1E',
                marginBottom: '12px', lineHeight: 1, letterSpacing: '-2px',
                position: 'relative', zIndex: 1
              }}>
                2026
              </div>
              <div style={{
                fontSize: '17px', fontWeight: '600', color: '#1C1C1E',
                marginBottom: '8px', position: 'relative', zIndex: 1
              }}>
                {t.about2026CardLabel}
              </div>
              <div style={{ fontSize: '15px', color: '#8E8E93', position: 'relative', zIndex: 1 }}>
                qaraa.asia × qaraa.crm
              </div>
            </div>

            {/* Улучшение экосистемы */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '32px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#8E8E93', letterSpacing: '1px', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {t.about2026Label}
                  <img src={kakmiImage} alt="" style={{ height: '16px', transform: 'rotate(15deg)' }} />
                </span>
              </div>
              <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1C1C1E', marginBottom: '20px' }}>
                {t.about2026Title}
              </h2>
              {t.about2026Paragraphs && t.about2026Paragraphs.map((text, i) => (
                <p key={i} style={{ fontSize: '15px', color: '#636366', lineHeight: '1.6', marginBottom: '16px' }}>
                  {text.split('{smile}').map((part, index, array) => (
                    <React.Fragment key={index}>
                      {part}
                      {index < array.length - 1 && (
                        <img src={smileImage} alt="smile" style={{ width: '26px', height: '26px', display: 'inline-block', verticalAlign: 'middle', transform: 'translateY(-2px)' }} />
                      )}
                    </React.Fragment>
                  ))}
                </p>
              ))}
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                <img src={qaraaCrmLogo} alt="qaraa.asia × qaraa.crm" style={{ height: '120px' }} />
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Values */}
      <section className="advantages-section" style={{
        padding: '80px 24px',
        background: 'white',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px',
        position: 'relative',
        zIndex: 3
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="advantages-header" style={{ textAlign: 'center', marginBottom: '60px', maxWidth: '900px', margin: '0 auto 60px' }}>
            <span style={{
              fontSize: '12px',
              fontWeight: '700',
              color: '#8E8E93',
              letterSpacing: '1.5px',
              display: 'inline-block',
              marginBottom: '16px'
            }}>
              {t.aboutValuesLabel}
            </span>
            <h2 className="advantages-title" style={{
              fontSize: '42px',
              fontWeight: '700',
              color: '#1C1C1E',
              marginBottom: '20px',
              lineHeight: '1.2',
              letterSpacing: '-1px'
            }}>
              {t.aboutValuesTitle}
            </h2>
            <p className="advantages-description" style={{
              fontSize: '19px',
              color: '#636366',
              lineHeight: '1.6',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              {t.aboutValuesDesc}
            </p>
          </div>
          <div className="advantages-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '24px'
          }}>
            {values.map((v, i) => (
              <div key={i} className="advantage-card" style={{
                background: '#F8F8F8',
                borderRadius: '20px',
                padding: '32px',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s ease',
                cursor: 'default',
                position: 'relative',
                overflow: 'hidden'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#FFFFFF'
                  e.currentTarget.style.transform = 'translateY(-8px)'
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.08)'
                  e.currentTarget.style.borderColor = '#1C1C1E'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#F8F8F8'
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'none'
                  e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.05)'
                }}>
                {/* Badge */}
                <div className="advantage-badge" style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  background: 'linear-gradient(135deg, #1C1C1E 0%, #3A3A3C 100%)',
                  color: 'white',
                  fontSize: '10px',
                  fontWeight: '700',
                  padding: '4px 10px',
                  borderRadius: '8px',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>
                  {v.badge}
                </div>

                {/* Icon with gradient background */}
                <div className="advantage-icon-wrapper" style={{
                  width: '64px',
                  height: '64px',
                  background: 'linear-gradient(135deg, #F2F2F7 0%, #E5E5EA 100%)',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
                }}>
                  <img src={v.icon} alt={v.title} style={{ width: '40px', height: '40px' }} />
                </div>

                {/* Title with underline effect */}
                <h3 style={{
                  fontSize: '22px',
                  fontWeight: '700',
                  color: '#1C1C1E',
                  marginBottom: '12px',
                  letterSpacing: '-0.5px',
                  position: 'relative',
                  paddingBottom: '8px'
                }}>
                  {v.title}
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '40px',
                    height: '3px',
                    background: 'linear-gradient(90deg, #1C1C1E 0%, transparent 100%)',
                    borderRadius: '2px'
                  }}></div>
                </h3>

                {/* Description */}
                <p style={{
                  fontSize: '16px',
                  color: '#636366',
                  lineHeight: '1.6',
                  margin: 0
                }}>
                  {v.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ — Minimalist */}
      <section className="faq-section" style={{
        paddingTop: '80px',
        paddingRight: '24px',
        paddingLeft: '24px',
        paddingBottom: '120px',
        background: '#F2F2F7',
        position: 'relative',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px',
        zIndex: 4
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '40px', fontWeight: '700', color: '#1C1C1E',
              margin: '0 0 16px', letterSpacing: '-1px'
            }}>
              {t.aboutFaqTitle}
            </h2>
            <p style={{ fontSize: '17px', color: '#8E8E93', margin: 0 }}>
              {t.aboutFaqDesc}
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {faqs.map((faq, i) => (
              <div key={i} style={{
                borderBottom: i === faqs.length - 1 ? 'none' : '1px solid #E5E5EA'
              }}>
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  style={{
                    width: '100%', padding: '24px 0',
                    background: 'transparent', border: 'none',
                    textAlign: 'left', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                  }}
                >
                  <span style={{
                    fontSize: '18px', fontWeight: '500', color: '#1C1C1E', paddingRight: '24px'
                  }}>{faq.q}</span>
                  <div style={{
                    position: 'relative', width: '20px', height: '20px'
                  }}>
                    <span style={{
                      position: 'absolute', top: '50%', left: '0', width: '20px', height: '2px',
                      background: '#1C1C1E', transform: 'translateY(-50%)', transition: 'all 0.3s ease'
                    }}></span>
                    <span style={{
                      position: 'absolute', top: '50%', left: '0', width: '20px', height: '2px',
                      background: '#1C1C1E', transform: openFaq === i ? 'translateY(-50%) rotate(0deg)' : 'translateY(-50%) rotate(90deg)',
                      transition: 'all 0.3s ease'
                    }}></span>
                  </div>
                </button>
                {openFaq === i && (
                  <div style={{
                    paddingBottom: '24px',
                    fontSize: '16px', color: '#636366',
                    lineHeight: '1.6'
                  }}>
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contacts & Office - Drinkit Style (Two Cards Side by Side) */}
      <section className="contacts-section" style={{
        paddingTop: '100px',
        paddingRight: '24px',
        paddingLeft: '24px',
        paddingBottom: '140px',
        background: 'white',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px',
        position: 'relative',
        zIndex: 5
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {/* Two Cards Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '24px',
            width: '100%'
          }}>

            {/* Card 1: Contacts */}
            <div style={{
              background: '#F8F9FA',
              borderRadius: '32px',
              padding: '48px 40px'
            }}>
              {/* Title */}
              <div style={{ marginBottom: '40px' }}>
                <h3 style={{
                  fontSize: '32px',
                  fontWeight: '700',
                  color: '#000000',
                  marginBottom: '12px',
                  letterSpacing: '-1px'
                }}>
                  {t.aboutContactTitle}
                </h3>
                <p style={{
                  fontSize: '16px',
                  color: '#666666',
                  margin: 0
                }}>
                  {t.aboutContactSubtitle}
                </p>
              </div>

              {/* Pills - Method Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                marginBottom: '32px',
                flexWrap: 'wrap'
              }}>
                <div style={{
                  background: '#4059F6',
                  color: 'white',
                  padding: '14px 28px',
                  borderRadius: '50px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  WhatsApp
                </div>
                <div style={{
                  background: '#4059F6',
                  color: 'white',
                  padding: '14px 28px',
                  borderRadius: '50px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  Telegram
                </div>
                <div style={{
                  background: '#4059F6',
                  color: 'white',
                  padding: '14px 28px',
                  borderRadius: '50px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  {t.aboutContactPhone}
                </div>
              </div>

              {/* Contact Info Cards */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '20px'
              }}>
                {contacts.map((c, i) => (
                  <a key={i} href={c.link} target="_blank" rel="noopener noreferrer" style={{
                    background: 'white',
                    padding: '24px',
                    borderRadius: '20px',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    transition: 'all 0.2s ease'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#FAFAFA'
                      e.currentTarget.style.transform = 'translateX(4px)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'white'
                      e.currentTarget.style.transform = 'translateX(0)'
                    }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '12px',
                      background: '#F8F9FA',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <img src={c.icon} alt={c.title} style={{ width: '24px', height: '24px' }} />
                    </div>
                    <div>
                      <div style={{
                        fontSize: '14px',
                        color: '#999999',
                        marginBottom: '4px',
                        fontWeight: '600'
                      }}>
                        {c.title}
                      </div>
                      <div style={{
                        fontSize: '18px',
                        color: '#000000',
                        fontWeight: '700',
                        letterSpacing: '-0.3px'
                      }}>
                        {c.value}
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Card 2: Office Address */}
            <div style={{
              background: '#F8F9FA',
              borderRadius: '32px',
              padding: '48px 40px'
            }}>
              {/* Title */}
              <div style={{ marginBottom: '40px' }}>
                <h3 style={{
                  fontSize: '32px',
                  fontWeight: '700',
                  color: '#000000',
                  marginBottom: '12px',
                  letterSpacing: '-1px'
                }}>
                  {t.aboutOfficeTitle}
                </h3>
                <p style={{
                  fontSize: '16px',
                  color: '#666666',
                  margin: 0
                }}>
                  {t.aboutOfficeSubtitle}
                </p>
              </div>

              {/* Pills - Cities */}
              <div style={{
                display: 'flex',
                gap: '12px',
                marginBottom: '32px',
                flexWrap: 'wrap'
              }}>
                <div style={{
                  background: '#4059F6',
                  color: 'white',
                  padding: '14px 28px',
                  borderRadius: '50px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  Астана
                </div>
                <div style={{
                  background: '#4059F6',
                  color: 'white',
                  padding: '14px 28px',
                  borderRadius: '50px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  Казахстан
                </div>
              </div>

              {/* Info Cards - Vertical Layout */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                marginBottom: '24px'
              }}>
                {/* Адрес */}
                <div style={{
                  padding: '24px 0',
                  textAlign: 'left'
                }}>
                  <div style={{
                    fontSize: '13px',
                    color: '#999999',
                    marginBottom: '12px',
                    fontWeight: '600',
                    textTransform: 'uppercase'
                  }}>
                    {t.aboutAddressLabel}
                  </div>
                  <div style={{
                    fontSize: '22px',
                    fontWeight: '700',
                    color: '#000000',
                    marginBottom: '6px',
                    letterSpacing: '-0.5px'
                  }}>
                    {t.footerAddress}
                  </div>
                  <div style={{
                    fontSize: '15px',
                    color: '#666666',
                    fontWeight: '500'
                  }}>
                    {t.footerCity}
                  </div>
                </div>

                {/* Поддержка */}
                <div style={{
                  padding: '24px 0',
                  textAlign: 'left'
                }}>
                  <div style={{
                    fontSize: '13px',
                    color: '#999999',
                    marginBottom: '12px',
                    fontWeight: '600',
                    textTransform: 'uppercase'
                  }}>
                    {t.aboutSupportLabel}
                  </div>
                  <div style={{
                    fontSize: '32px',
                    fontWeight: '800',
                    color: '#000000',
                    letterSpacing: '-1px',
                    lineHeight: '1'
                  }}>
                    24/7
                  </div>
                </div>

                {/* Офис */}
                <div style={{
                  padding: '24px 0',
                  textAlign: 'left'
                }}>
                  <div style={{
                    fontSize: '13px',
                    color: '#999999',
                    marginBottom: '12px',
                    fontWeight: '600',
                    textTransform: 'uppercase'
                  }}>
                    {t.aboutOfficeLabel}
                  </div>
                  <div style={{
                    fontSize: '18px',
                    fontWeight: '700',
                    color: '#000000',
                    letterSpacing: '-0.5px'
                  }}>
                    {t.aboutOfficeHours}
                  </div>
                </div>
              </div>

              {/* Map */}
              <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                height: '300px',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)'
              }}>
                {loadMap && (
                  <iframe
                    src="https://yandex.ru/map-widget/v1/?ll=71.437457%2C51.100200&z=16&pt=71.437457,51.100200,pm2rdm"
                    width="100%"
                    height="100%"
                    className="about-map-iframe"
                    style={{ border: 0, display: 'block', filter: 'grayscale(20%) contrast(105%)' }}
                    allowFullScreen={true}
                    loading="lazy"
                  ></iframe>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Business Section */}
      <section style={{
        padding: '40px 0 100px',
        background: '#FFFFFF',
        position: 'relative',
        zIndex: 3,
        overflow: 'hidden'
      }}>
        <div className="biz-hero-wrap" style={{ width: '100%', margin: '0 auto', marginBottom: '40px' }}>
          {/* Фото вместо текста (biz1) */}
          <div className="biz-hero-inner" style={{
            width: '100%', margin: '0 auto',
            borderRadius: '24px', overflow: 'hidden',
            boxShadow: '0 8px 40px rgba(0,0,0,0.06)'
          }}>
            <img
              src={biz1Image}
              alt="qaraa presentation"
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          </div>
        </div>

        {/* Галерея — drag-to-scroll */}
        <style>{`
          .biz-hero-wrap {
            padding: 0 24px;
          }
          @media (max-width: 768px) {
            .biz-hero-wrap {
              padding: 0;
            }
            .biz-hero-inner {
              border-radius: 0 !important;
            }
          }
          .biz-gallery-wrap {
            overflow: hidden;
            padding: 16px 0;
          }
          .biz-track {
            display: flex;
            gap: 24px;
            padding: 0 24px;
            cursor: grab;
            user-select: none;
            -webkit-user-select: none;
            will-change: transform;
          }
          .biz-track.dragging {
            cursor: grabbing;
          }
          .biz-img-wrap {
            flex-shrink: 0;
            width: 85vw; /* Почти на весь экран, чтобы было видно следующий слайд */
            max-width: 1200px;
            height: auto;
            border-radius: 24px;
            overflow: hidden;
            background: transparent;
            box-shadow: 0 4px 24px rgba(0,0,0,0.08);
            pointer-events: none;
          }
          .biz-img-wrap img {
            width: 100%;
            height: auto;
            display: block;
          }
        `}</style>

        <div className="biz-gallery-wrap">
          <div
            className="biz-track"
            ref={(el) => {
              if (!el || el._dragInit) return;
              el._dragInit = true;
              let isDown = false, startX = 0, scrollLeft = 0;
              el.addEventListener('mousedown', (e) => {
                isDown = true;
                el.classList.add('dragging');
                startX = e.pageX - el.offsetLeft;
                scrollLeft = el.scrollLeft;
              });
              el.addEventListener('mouseleave', () => { isDown = false; el.classList.remove('dragging'); });
              el.addEventListener('mouseup', () => { isDown = false; el.classList.remove('dragging'); });
              el.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - el.offsetLeft;
                el.scrollLeft = scrollLeft - (x - startX) * 1.5;
              });
            }}
            style={{ overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {[biz2Image, biz3Image, biz4Image].map((img, idx) => (
              <div key={idx} className="biz-img-wrap">
                <img src={img} alt={`qaraa business screen ${idx + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        {/* Кнопка */}
        <div style={{ maxWidth: '1200px', margin: '40px auto 0', padding: '0 24px', textAlign: 'center' }}>
          <button
            onClick={() => navigate('/business')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              padding: '16px 36px',
              background: '#4059F6',
              border: 'none',
              borderRadius: '100px',
              fontSize: '17px',
              fontWeight: '600',
              color: '#FFFFFF',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              boxShadow: '0 4px 20px rgba(64,89,246,0.3)'
            }}
            onMouseEnter={(e) => { e.target.style.transform = 'scale(1.03)'; e.target.style.boxShadow = '0 8px 28px rgba(64,89,246,0.4)' }}
            onMouseLeave={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 20px rgba(64,89,246,0.3)' }}
          >
            Партнёрство с qaraa
            <img src={heartqaraaImage} alt="heart qaraa" style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
          </button>
        </div>
      </section>



      {/* Footer */}
      <footer style={{
        paddingTop: '80px',
        paddingRight: '24px',
        paddingLeft: '24px',
        paddingBottom: '50px',
        background: 'linear-gradient(135deg, #F2F2F7 0%, #E5E5EA 100%)',
        color: '#1C1C1E',
        position: 'relative',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px',
        zIndex: 6
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '50px',
            marginBottom: '50px'
          }}>
            <div>
              <div style={{
                fontSize: '24px',
                fontWeight: '800',
                marginBottom: '16px',
                color: '#1C1C1E',
                letterSpacing: '-0.5px'
              }}>qaraa.asia</div>
              <div style={{
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'flex-start'
              }}>
                <img
                  src={qaraaCrmLogo}
                  alt="qaraa × qaraa.crm"
                  style={{
                    height: '100px',
                    width: 'auto'
                  }}
                />
              </div>
              <div style={{ fontSize: '15px', color: '#636366', fontWeight: '500' }}>{t.logoSubtitle}</div>
            </div>
            <div>
              <div style={{
                fontSize: '13px',
                fontWeight: '800',
                color: '#8E8E93',
                marginBottom: '20px',
                letterSpacing: '1.2px',
                textTransform: 'uppercase'
              }}>{t.footerNavigation}</div>
              {[{ name: t.footerAbout, path: '/about-us' }, { name: t.footerBonusCard, path: '/card-info' }, { name: t.footerVacancies, path: '/vacancies' }, { name: t.footerBusiness, path: '/business' }].map(l => (
                <div key={l.path} onClick={() => navigate(l.path)} style={{
                  fontSize: '15px',
                  marginBottom: '12px',
                  cursor: 'pointer',
                  color: '#1C1C1E',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#5856D6'
                    e.currentTarget.style.paddingLeft = '8px'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#1C1C1E'
                    e.currentTarget.style.paddingLeft = '0'
                  }}>
                  {l.name}
                </div>
              ))}
            </div>
            <div>
              <div style={{
                fontSize: '13px',
                fontWeight: '800',
                color: '#8E8E93',
                marginBottom: '20px',
                letterSpacing: '1.2px',
                textTransform: 'uppercase'
              }}>{t.footerSocial}</div>
              {[
                { name: 'Instagram', url: 'https://www.instagram.com/qaraa.kz?igsh=cWw3cmlsNmJ0ZHRi' },
                { name: 'TikTok', url: 'https://www.tiktok.com/@qaraa.kz?_r=1&_t=ZM-91EaJ8tj6Do' },
                { name: 'Telegram', url: 'https://t.me/qaraa_kz' },
                { name: 'WhatsApp', url: 'https://wa.me/77778307588' }
              ].map(s => (
                <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer" style={{
                  display: 'block',
                  fontSize: '15px',
                  color: '#1C1C1E',
                  fontWeight: '500',
                  textDecoration: 'none',
                  marginBottom: '12px',
                  transition: 'all 0.2s ease'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#5856D6'
                    e.currentTarget.style.paddingLeft = '8px'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#1C1C1E'
                    e.currentTarget.style.paddingLeft = '0'
                  }}>
                  {s.name}
                </a>
              ))}
            </div>
            <div>
              <div style={{
                fontSize: '13px',
                fontWeight: '800',
                color: '#8E8E93',
                marginBottom: '20px',
                letterSpacing: '1.2px',
                textTransform: 'uppercase'
              }}>{t.footerInfo}</div>
              <div style={{ fontSize: '15px', marginBottom: '12px', color: '#1C1C1E', fontWeight: '500' }}>+7 777 830 75 88</div>
              <div style={{ fontSize: '15px', color: '#636366', fontWeight: '500' }}>{t.footerCity}</div>
              <div style={{ fontSize: '15px', marginTop: '12px', color: '#636366', fontWeight: '500' }}>{t.footerAddress}</div>
            </div>
          </div>
          <div style={{
            marginTop: '80px',
            paddingTop: '40px',
            borderTop: '2px solid rgba(0, 0, 0, 0.06)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '20px',
            fontSize: '15px',
            color: '#8E8E93',
            fontWeight: '600'
          }}>
            <div>{t.footerRights}</div>
            <div style={{ display: 'flex', gap: '24px' }}>
              <span onClick={() => navigate('/privacy')} style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#5856D6'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#8E8E93'
                }}>
                {t.footerPrivacy}
              </span>
              <span onClick={() => navigate('/terms')} style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#5856D6'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#8E8E93'
                }}>
                {t.footerTerms}
              </span>
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Styles */}
      <style>{`
        @media (max-width: 768px) {
          .lang-text-label { display: none !important; }
          .lang-chevron { display: none !important; }
          .home-logo-subtitle.desktop-only-subtitle { display: none !important; }
          .mobile-only-subtitle { display: none !important; }
          .home-header-container { padding: 14px 16px !important; }
          .home-logo-container { gap: 10px !important; }

          /* Header - мобильная версия */
          .home-header-buttons { display: none !important; }
          .home-header-button-login,
          .home-header-button-register { display: none !important; }
          .home-mobile-menu-button {
            display: flex !important;
            flex-direction: column !important;
            gap: 5px !important;
          }
          
          /* Logo в хедере */
          header > div {
            padding: 16px 20px !important;
          }
          
          header > div > div:first-child {
            gap: 12px !important;
          }
          
          header > div > div:first-child > img {
            height: 35px !important;
          }
          
          header > div > div:first-child > div > div:first-child {
            font-size: 16px !important;
          }
          
          header > div > div:first-child > div > div:last-child {
            font-size: 11px !important;
          }
          
          /* Hero Section */
          .home-hero-section {
            padding-top: 70px !important;
          }
          .home-hero-container {
            grid-template-columns: 1fr !important;
            padding: 0 20px !important;
          }
          .home-hero-text-wrapper {
            display: contents;
          }
          .about-hero-main-title {
            order: 1;
            font-size: 42px !important;
          }
          .home-human-container {
            order: 2;
          }
          .about-hero-description-desktop {
            display: none !important;
          }
          .about-hero-description-mobile {
            display: block !important;
            order: 3;
            margin-bottom: 40px !important;
          }
          
          /* Story Section - мобильная */
          .home-hero-section + section {
            padding-top: 50px !important;
          }
          
          .home-hero-section + section > div > div {
            gap: 20px !important;
            margin-bottom: 20px !important;
          }
          
          .home-hero-section + section > div > div > div:last-child {
            margin-bottom: 40px !important;
          }
          
          /* Преимущества секция - мобильная */
          .advantages-section {
            padding: 50px 16px !important;
          }
          
          .advantages-header {
            text-align: center !important;
            margin-bottom: 40px !important;
            max-width: 100% !important;
          }
          
          .advantages-title {
            font-size: 32px !important;
            line-height: 1.2 !important;
            letter-spacing: -0.5px !important;
            margin-bottom: 16px !important;
          }
          
          .advantages-description {
            font-size: 16px !important;
            line-height: 1.6 !important;
            padding: 0 8px !important;
          }
          
          .advantages-grid {
            gap: 16px !important;
            grid-template-columns: 1fr !important;
          }
          
          .advantage-card {
            padding: 24px 20px !important;
            border-radius: 20px !important;
            min-height: auto !important;
          }
          
          .advantage-card h3 {
            font-size: 19px !important;
            margin-bottom: 10px !important;
            padding-bottom: 8px !important;
          }
          
          .advantage-card h3 div {
            width: 32px !important;
            height: 2px !important;
          }
          
          .advantage-card p {
            font-size: 15px !important;
            line-height: 1.5 !important;
          }
          
          .advantage-icon-wrapper {
            width: 56px !important;
            height: 56px !important;
            margin-bottom: 18px !important;
            border-radius: 14px !important;
          }
          
          .advantage-icon-wrapper img {
            width: 34px !important;
            height: 34px !important;
          }
          
          .advantage-badge {
            font-size: 9px !important;
            padding: 4px 8px !important;
            top: 12px !important;
            right: 12px !important;
            border-radius: 6px !important;
          }
          
          .advantage-card:last-child {
            margin-bottom: 40px !important;
          }
          
          /* FAQ секция - мобильная */
          .faq-section {
            padding: 50px 16px !important;
          }
          
          .faq-header {
            margin-bottom: 40px !important;
          }
          
          .faq-title {
            font-size: 32px !important;
            margin-bottom: 16px !important;
            letter-spacing: -0.5px !important;
          }
          
          .faq-description {
            font-size: 15px !important;
            line-height: 1.5 !important;
            padding: 0 8px !important;
          }
          
          .faq-list {
            gap: 12px !important;
          }
          
          .faq-item {
            border-radius: 14px !important;
          }
          
          .faq-button {
            padding: 20px 18px !important;
            gap: 16px !important;
          }
          
          .faq-question {
            font-size: 16px !important;
            line-height: 1.4 !important;
          }
          
          .faq-icon {
            min-width: 30px !important;
            height: 30px !important;
            flex-shrink: 0 !important;
          }
          
          .faq-icon span {
            font-size: 16px !important;
          }
          
          .faq-answer {
            padding: 0 18px 20px !important;
            padding-top: 20px !important;
            font-size: 14px !important;
            line-height: 1.6 !important;
          }
          
          .faq-list {
            margin-bottom: 40px !important;
          }
          
          /* Контакты секция - мобильная */
          .contacts-section {
            padding: 60px 20px 100px !important;
            margin-bottom: 0 !important;
          }
          
          /* Two Cards Grid - мобильная */
          .contacts-section > div > div:first-child {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
          
          .contacts-section > div > div:first-child > div {
            width: 100% !important;
          }
          
          .contacts-section > div > div:first-child > div > div:first-child {
            margin-bottom: 24px !important;
          }
          
          .contacts-section > div > div:first-child > div > div:first-child h3 {
            font-size: 28px !important;
          }
          
          .contacts-section > div > div:first-child > div > div:first-child p {
            font-size: 14px !important;
          }
          
          .contacts-header {
            margin-bottom: 40px !important;
          }
          
          .contacts-title {
            font-size: 36px !important;
            margin-bottom: 16px !important;
            letter-spacing: -1px !important;
          }
          
          .contacts-description {
            font-size: 16px !important;
            line-height: 1.5 !important;
            padding: 0 !important;
          }
          
          .contacts-grid {
            display: flex !important;
            grid-template-columns: none !important;
            gap: 16px !important;
            overflow-x: auto !important;
            scroll-snap-type: x mandatory !important;
            -webkit-overflow-scrolling: touch !important;
            padding: 0 20px !important;
            margin: 0 -20px !important;
          }
          
          .contacts-grid::-webkit-scrollbar {
            display: none !important;
          }
          
          .contact-card {
            min-width: 280px !important;
            max-width: 280px !important;
            flex-shrink: 0 !important;
            padding: 36px 28px !important;
            border-radius: 24px !important;
            scroll-snap-align: start !important;
          }
          
          .contact-icon {
            width: 64px !important;
            height: 64px !important;
            margin-bottom: 20px !important;
            border-radius: 16px !important;
          }
          
          .contact-icon img {
            width: 32px !important;
            height: 32px !important;
          }
          
          .contact-title {
            font-size: 20px !important;
            margin-bottom: 10px !important;
          }
          
          .contact-value {
            font-size: 16px !important;
          }
          
          /* Office Card - мобильная */
          .office-card {
            padding: 40px 24px !important;
            border-radius: 24px !important;
          }
          
          .office-title {
            font-size: 28px !important;
            margin-bottom: 10px !important;
          }
          
          .office-subtitle {
            font-size: 15px !important;
          }
          
          /* City pills в одну колонку */
          .office-card > div:nth-child(2) {
            flex-direction: column !important;
            gap: 12px !important;
            margin-bottom: 24px !important;
          }
          
          .office-card > div:nth-child(2) > div {
            padding: 14px 24px !important;
            font-size: 16px !important;
            width: 100% !important;
            text-align: center !important;
          }
          
          /* Info cards в одну колонку */
          .office-card > div:nth-child(3) {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
            margin-bottom: 24px !important;
          }
          
          .office-card > div:nth-child(3) > div {
            padding: 24px 20px !important;
            border-radius: 16px !important;
          }
          
          .office-card > div:nth-child(3) > div > div:nth-child(2) {
            font-size: 32px !important;
          }
          
          /* Features list */
          .office-card > div:nth-child(4) {
            gap: 12px !important;
            margin-bottom: 24px !important;
          }
          
          .office-card > div:nth-child(4) > div {
            padding: 14px !important;
            border-radius: 10px !important;
          }
          
          .office-card > div:nth-child(4) > div > div:last-child {
            font-size: 14px !important;
          }
          
          /* Map */
          .office-map {
            height: 300px !important;
            border-radius: 16px !important;
          }
          
          .office-info-cards > div:first-child > div:first-child {
            font-size: 10px !important;
            margin-bottom: 10px !important;
          }
          
          .office-info-cards > div:first-child > div:nth-child(2) {
            font-size: 16px !important;
          }
          
          .office-info-cards > div:first-child > div:last-child {
            font-size: 14px !important;
          }
          
          .office-info-cards > div:last-child {
            gap: 12px !important;
          }
          
          .office-info-cards > div:last-child > div {
            padding: 16px !important;
            border-radius: 12px !important;
          }
          
          .office-info-cards > div:last-child > div > div:first-child {
            font-size: 10px !important;
            margin-bottom: 6px !important;
          }
          
          .office-info-cards > div:last-child > div:nth-child(1) > div:last-child {
            font-size: 20px !important;
          }
          
          .office-info-cards > div:last-child > div:nth-child(2) > div:last-child {
            font-size: 15px !important;
          }
          
          .office-map {
            min-height: 250px !important;
            height: 250px !important;
            max-width: 100% !important;
            border-radius: 14px !important;
          }
        }

        @media (max-width: 900px) {
          section > div > div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 600px) {
          section > div > div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
            grid-template-columns: 1fr !important;
          }
        }

        @media (max-width: 480px) {
          .home-hero-section {
            padding-top: 70px !important;
            padding-bottom: 50px !important;
          }

          .home-hero-container {
            padding: 0 16px !important;
          }

          .about-hero-main-title {
            font-size: 32px !important;
            letter-spacing: -1px !important;
            margin-bottom: 20px !important;
          }

          .about-hero-description-mobile {
            font-size: 16px !important;
          }
          
          /* Преимущества - маленькие экраны */
          .advantages-section {
            padding: 40px 16px !important;
          }
          
          .advantages-title {
            font-size: 28px !important;
            margin-bottom: 14px !important;
          }
          
          .advantages-description {
            font-size: 15px !important;
            line-height: 1.5 !important;
          }
          
          .advantage-card {
            padding: 20px 18px !important;
            border-radius: 18px !important;
          }
          
          .advantage-card h3 {
            font-size: 18px !important;
            margin-bottom: 8px !important;
          }
          
          .advantage-card p {
            font-size: 14px !important;
            line-height: 1.5 !important;
          }
          
          .advantage-icon-wrapper {
            width: 52px !important;
            height: 52px !important;
            margin-bottom: 16px !important;
            border-radius: 12px !important;
          }
          
          .advantage-icon-wrapper img {
            width: 32px !important;
            height: 32px !important;
          }
          
          .advantage-badge {
            font-size: 8px !important;
            padding: 3px 7px !important;
            top: 10px !important;
            right: 10px !important;
          }
          
          /* FAQ - маленькие экраны */
          .faq-section {
            padding: 40px 16px !important;
          }
          
          .faq-title {
            font-size: 28px !important;
          }
          
          .faq-description {
            font-size: 14px !important;
          }
          
          .faq-button {
            padding: 18px 16px !important;
            gap: 12px !important;
          }
          
          .faq-question {
            font-size: 15px !important;
          }
          
          .faq-icon {
            min-width: 28px !important;
            height: 28px !important;
          }
          
          .faq-icon span {
            font-size: 15px !important;
          }
          
          .faq-answer {
            padding: 0 16px 18px !important;
            padding-top: 18px !important;
            font-size: 13px !important;
          }
          
          /* Контакты - маленькие экраны */
          .contacts-section {
            padding: 40px 16px 100px !important;
          }
          
          .contacts-title {
            font-size: 28px !important;
          }
          
          .contacts-description {
            font-size: 14px !important;
          }
          
          .contact-card {
            padding: 28px 20px !important;
            border-radius: 18px !important;
          }
          
          .contact-icon {
            width: 60px !important;
            height: 60px !important;
            margin-bottom: 18px !important;
            border-radius: 14px !important;
          }
          
          .contact-icon img {
            width: 30px !important;
            height: 30px !important;
          }
          
          .contact-title {
            font-size: 19px !important;
          }
          
          .contact-value {
            font-size: 15px !important;
          }
          
          .office-card {
            padding: 28px 18px !important;
            border-radius: 18px !important;
          }
          
          .office-title {
            font-size: 22px !important;
          }
          
          .office-subtitle {
            font-size: 13px !important;
          }
          
          .office-content {
            gap: 18px !important;
          }
          
          .office-info-cards > div:first-child {
            padding: 18px !important;
          }
          
          .office-info-cards > div:first-child > div:nth-child(2) {
            font-size: 15px !important;
          }
          
          .office-info-cards > div:first-child > div:last-child {
            font-size: 13px !important;
          }
          
          .office-info-cards > div:last-child > div {
            padding: 14px !important;
          }
          
          .office-info-cards > div:last-child > div:nth-child(1) > div:last-child {
            font-size: 18px !important;
          }
          
          .office-info-cards > div:last-child > div:nth-child(2) > div:last-child {
            font-size: 14px !important;
          }
          
          .office-map {
            min-height: 220px !important;
            height: 220px !important;
          }
          
          /* Footer - мобильная версия */
          .contacts-section {
            position: relative !important;
            z-index: 5 !important;
          }
          
          footer {
            position: relative !important;
            z-index: 6 !important;
            margin-top: -40px !important;
            padding: 50px 20px 35px !important;
            border-radius: 60px 60px 0 0 !important;
            overflow: hidden !important;
          }
          
          footer > div:first-child {
            padding: 0 !important;
            max-width: 100% !important;
            margin: 0 !important;
          }
          
          footer > div:first-child > div:first-child {
            grid-template-columns: 1fr !important;
            gap: 35px !important;
            margin-bottom: 35px !important;
            padding: 0 !important;
          }
          
          footer > div:first-child > div:first-child > div:first-child > div:first-child {
            font-size: 20px !important;
            margin-bottom: 10px !important;
          }
          
          footer > div:first-child > div:first-child > div:first-child > div:last-child {
            font-size: 14px !important;
          }
          
          footer > div:first-child > div:first-child > div > div:first-child {
            font-size: 11px !important;
            margin-bottom: 15px !important;
          }
          
          footer > div:first-child > div:first-child > div > div:not(:first-child),
          footer > div:first-child > div:first-child > div > a {
            font-size: 14px !important;
            margin-bottom: 10px !important;
          }
          
          footer > div:first-child > div:last-child {
            margin-top: 50px !important;
            padding-top: 30px !important;
            border-top: 2px solid rgba(0, 0, 0, 0.06) !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 16px !important;
            font-size: 13px !important;
          }
          
          footer > div:first-child > div:last-child > div:last-child {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 12px !important;
          }
        }
      `}</style>
    </div>
  )
}
